import { styled } from '@mui/material';
import { grey } from '@mui/material/colors';

export const InputRoot = styled('div')(({ isFullWidth }: { isFullWidth?: boolean }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: isFullWidth ? '100%' : 'auto',
  '& svg': {
    fill: grey['500'],
  },
}));
